import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Overlay from '../Overlay';
import WizardTiles from './WizardTiles';
import WizardBody from './WizardBody';
import {
  getAllUserTypeRoles,
  fetchAllItemTypes,
} from 'src/store/actions/formOptions';
import { selectFormOptions } from 'src/store/selectors/formOptions';
import { upload } from 'src/helpers/upLoadHelper';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { clearContactFormData } from 'src/store/actions/contactForm';
import { clearPropertyFormData } from 'src/store/actions/propertyForm';
import { saveProperty as savePropertyAction } from 'src/store/actions/properties';
import { clearItemFormData } from 'src/store/actions/itemForm';
import { saveItem as saveItemAction } from 'src/store/actions/items';
import { clearSelectedModulePermission } from 'src/store/actions/tabSelections';
import { exitServiceRequestForm } from 'src/store/actions/serviceRequestForm';
import {
  useContactFormSubmissionContacts
} from 'src/pages/SharedPageCustomHooks/UseContactSaveContactsPage/useContactFormSubmission';
import './Wizard.scss';

interface WizardProps {
  onClose: () => void;
  showOverlay: boolean;
}

const Wizard = ({ onClose, showOverlay }: WizardProps) => {
  const [active, setActive] = useState<any>(null);

  const dispatch = useDispatch();
  const formOptions = useSelector(selectFormOptions);
  const user = useSelector(selectAuthenticatedUser);
  const tabList = useSelector((state: any) => state.tabSelections.tabList);
  
  const { handleSubmitContactForm } = useContactFormSubmissionContacts({
    onSuccess: undefined,
    onClose: () => {
      setActive(null);
      onClose();
    },
  });
  
  
  useEffect(() => {
    dispatch(clearSelectedModulePermission());
    dispatch(getAllUserTypeRoles());
    if (formOptions.allItemTypes.length === 0) {
      dispatch(fetchAllItemTypes());
    }
    dispatch(exitServiceRequestForm());
  }, []);

  const saveProperty = async (data: any, actionType: any) => {
    let params = {};

    let imageUrl = null;

    if (data.selectedImage && data.selectedImage.length > 0) {
      imageUrl = await upload(data.selectedImage[0]);
    }

    let stages =
      data.constructionStages && data.constructionStages.length > 0
        ? data.constructionStages.filter((cs) => !cs.new)
        : [];

    params = {
      Name: data.name,
      AddressLine1: data.addressLine1,
      AddressLine2: '',
      City: data.city,
      Province: data.province,
      PostalCode: data.postalCode,
      Latitude: '17.5896',
      Longitude: '17.556896',
      Image: imageUrl,
      UserId: user.id,
      PropertyManagerId: data.propertyManagerId,
      ConstructionStages: stages,
      modulePermissions: data.modulePermissions || [],
    };

    dispatch(savePropertyAction(params));
  };

  const onSaveItem = (item: any) => {
    let properties = [];
    if (item.selectedProperties && item.selectedProperties.length > 0) {
      item.selectedProperties.map((sp) => {
        properties = [...properties, { id: sp.value }];
      });
    }
    let params = {
      Name: item.name,
      MakeName: item.makeName,
      Model: item.model,
      TypeId: item.typeId,
      WarrantyYears: item.warrantyYears,
      UserId: user.id,
      properties: properties,
    };
    dispatch(saveItemAction(params));
  };

  const onBack = () => {
    setActive(null);
    dispatch(clearPropertyFormData());
    dispatch(clearContactFormData());
    dispatch(clearItemFormData());
  };

  return (
    <Overlay
      showOverlay={showOverlay}
      content={
        <>
          {active ? (
            <WizardBody
              active={active}
              onBack={() => onBack()}
              onClose={() => {
                setActive(null);
                onClose();
              }}
              saveProperty={saveProperty}
              onSubmitContactForm={handleSubmitContactForm}
              onSaveItem={onSaveItem}
              tabList={tabList}
            />
          ) : (
            <WizardTiles
              onChange={(active) => {
                setActive(active);
                dispatch(clearSelectedModulePermission());
              }}
              onClose={onClose}
              tiles={
                user.roles[0].role.name === 'Admin' ||
                user.roles[0].role.name === 'Super Admin'
                  ? ['Service Request', 'Property', 'Contact', 'Item']
                  : ['Service Request', 'Contact', 'Item']
              }
            />
          )}
        </>
      }
    />
  );
};

export default Wizard;
